const EXTRANET_GROUPS = [
  'extranet_CoDi',
  'extranet_GeOp',
  'extranet_Supervisor',
  'extranet_Cliente'
]

const SUPPLIERS_GROUPS = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras',
  'DesProveedores',
  'CoorProveeduria',
  'GeLogistica',
  'Proveeduría'
]

const SUPPLIER_GROUPS_LOW_TIER = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras'
  // 'Desarrollador Proveedores'
]

export { EXTRANET_GROUPS, SUPPLIERS_GROUPS, SUPPLIER_GROUPS_LOW_TIER }
